// staticGraphToShow:
// 0 - Main Static graph
// 1 - Second Static graph
const initialState = {
  graphNames: [
    'margin_sales_per_day',
    'marketplace_pie',
    'held_over_time_total',
    'held_over_time_by_cost',
    'primary_gte_1000',
    'primary_sub_1000',
    'tm_resale',
    'sh_resale',
    'sh_num_viewing',
    'sh_total_daily_sales',
    'sh_min_price',
    'sh_3_min_price',
    'sh_bottom_price',
  ],
  graphs: [],
  eventMeta: {
    links: [],
    name: '',
    days_until_event: 0,
    event_date: '',
    venue: {
      name: '',
      max_capacity: 0,
    },
    tm_stats: {
      event_capacity: 0,
    },
    sb_stats: {
      days_since_last_purchase: '',
    },
    sh_stats: {
      three_sales_ma: '',
    },
  },
  loaders: {
    meta: true,
    graphs: true,
    primaryQty: true,
    pastEvents: true,
    thresholdEvents: true,
  },
  primaryQtyData: {},
  graphsInfo: {
    primary_sub_1000: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      showDialogMulti: false,
      showDialogMultiSingle: false,
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: true,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
      nameSecondStaticGraph: 'primary_onsale_sub_1000',
      dataSecondStaticGraph: {
        name: 'Onsale Graph',
        url: '',
      },
      loading: false,
    },
    primary_gte_1000: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: true,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
      nameSecondStaticGraph: 'primary_onsale_gte_1000',
      dataSecondStaticGraph: {
        name: 'Onsale Graph',
        url: '',
      },
      thirdStaticGraph: true,
      showThirdStaticGraph: false,
      loadedThirdStaticGraph: false,
      nameThirdStaticGraph: 'total_quantity_available',
      dataThirdStaticGraph: {
        name: 'Total Quantity',
        url: '',
      },
      loading: false,
    },
    total_quantity_available: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
    },
    margin_sales_per_day: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      chartType: 'column,line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    marketplace_pie: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      chartType: 'pie',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    held_over_time_total: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    held_over_time_by_cost: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    tm_resale: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    sh_resale: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    sh_num_viewing: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    sh_total_daily_sales: {
      showChart: false,
      loadedData: false,
      dataAvailable: false,
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: false,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
    },
    sh_min_price: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: true,
      showSecondStaticGraph: false,
      loadedSecondStaticGraph: false,
      nameSecondStaticGraph: 'sh_min_price_one_day',
      dataSecondStaticGraph: {
        name: 'One Day',
        url: '',
      },
    },
    sh_3_min_price: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: true,
      showSecondStaticGraph: true,
      loadedSecondStaticGraph: false,
      nameSecondStaticGraph: 'sh_3_min_price_one_day',
      dataSecondStaticGraph: {
        name: 'One Day',
        url: '',
      },
    },
    sh_bottom_price: {
      showChart: false,
      loadedData: false,
      dataAvailable: true,
      chartType: 'line',
      data: {},
      staticGraphToShow: 0,
      showMainStaticGraph: true,
      secondStaticGraph: true,
      showSecondStaticGraph: true,
      loadedSecondStaticGraph: false,
      nameSecondStaticGraph: 'sh_bottom_price_one_day',
      dataSecondStaticGraph: {
        name: 'One Day',
        url: '',
      },
    },
  },
  pastEventsData: {},
  baseColumnsPastEvents: [
    {
      headerName: 'Date',
      field: 'event_date',
      pinned: 'left',
      filter: 'agTextColumnFilter',
      lockPinned: true,
      suppressMenu: true,
      minWidth: 100,
      sortable: false,
      resizable: true,
      cellRenderer: params => params.value,
    },
    {
      headerName: 'Venue',
      field: 'venue',
      pinned: 'left',
      filter: 'agTextColumnFilter',
      lockPinned: true,
      suppressMenu: true,
      minWidth: 80,
      sortable: false,
      resizable: true,
    },
    {
      headerName: 'City',
      field: 'city',
      pinned: 'left',
      filter: 'agTextColumnFilter',
      lockPinned: true,
      suppressMenu: true,
      minWidth: 50,
      sortable: false,
      resizable: true,
    },
    {
      headerName: 'St',
      field: 'state',
      pinned: 'left',
      filter: 'agTextColumnFilter',
      lockPinned: true,
      suppressMenu: true,
      minWidth: 55,
      sortable: false,
      resizable: true,
    },
  ],
  creatingThreshold: false,
  creatingThresholdResponse: true,
  eventThresholds: [],
};

initialState.graphs = initialState.graphNames.map(graphName => ({
  name: graphName,
  source: null,
  display_name: null,
  looker_link: null,
}));

const staticLookerDashboard = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_GRAPHS':
      return {
        ...state,
        loaders: {
          ...state.loaders,
          graphs: true,
        },
      };
    case 'GET_META':
      return {
        ...state,
        loaders: {
          ...state.loaders,
          meta: true,
        },
      };
    case 'GET_PRIMARY_QTY_DATA':
      return {
        ...state,
        loaders: {
          graphs: state.loaders.graphs,
          meta: state.loaders.meta,
          primaryQty: true,
          pastEvents: state.loaders.pastEvents,
          thresholdEvents: state.loaders.thresholdEvents,
        },
      };
    case 'GET_PAST_EVENTS_DATA':
      return {
        ...state,
        loaders: {
          ...state.loaders,
          pastEvents: action.payload,
        },
      };
    case 'EVENT_THRESHOLDS_LOADING':
      return {
        ...state,
        loaders: {
          ...state.loaders,
          thresholdEvents: action.payload,
        },
      };
    case 'FETCH_GRAPHS_SUCCESS':
      return {
        ...state,
        graphs: action.payload,
        loaders: {
          ...state.loaders,
          graphs: false,
        },
      };
    case 'FETCH_EVENT_META_SUCCESS':
      return {
        ...state,
        eventMeta: action.payload,
        loaders: {
          ...state.loaders,
          meta: false,
        },
      };
    case 'FETCH_PRIMARY_QTY_DATA_SUCCESS':
      return {
        ...state,
        primaryQtyData: action.payload,
        loaders: {
          ...state.loaders,
          primaryQty: false,
        },
      };
    case 'SHOW_HIDE_CHART':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload]: {
            ...state.graphsInfo[action.payload],
            showChart: !state.graphsInfo[action.payload].showChart,
            showMainStaticGraph: state.graphsInfo[action.payload].showChart,
            staticGraphToShow: 0,
            showSecondStaticGraph: false,
          },
        },
      };
    case 'GET_CHART_DATA':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload]: {
            ...state.graphsInfo[action.payload],
            showChart: true,
            staticGraphToShow: 0,
            showMainStaticGraph: false,
            showSecondStaticGraph: false,
          },
        },
      };
    case 'FETCH_CHART_DATA_SUCCESS':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.graphName]: {
            ...state.graphsInfo[action.payload.graphName],
            loadedData: true,
            data: action.payload.data,
          },
        },
      };
    case 'SHOW_MAIN_STATIC_GRAPH':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload]: {
            ...state.graphsInfo[action.payload],
            showChart: false,
            staticGraphToShow: 0,
            showMainStaticGraph: true,
            showSecondStaticGraph: false,
            showThirdStaticGraph: false,
          },
        },
      };
    case 'SHOW_SECOND_STATIC_GRAPH':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload]: {
            ...state.graphsInfo[action.payload],
            showChart: false,
            staticGraphToShow: 1,
            showMainStaticGraph: false,
            showThirdStaticGraph: false,
            showSecondStaticGraph: true,
          },
        },
      };
    case 'SHOW_THIRD_STATIC_GRAPH':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload]: {
            ...state.graphsInfo[action.payload],
            showChart: false,
            staticGraphToShow: 1,
            showMainStaticGraph: false,
            showSecondStaticGraph: false,
            showThirdStaticGraph: true,
          },
        },
      };
    case 'FETCH_SINGLE_STATIC_GRAPHS_SUCCESS':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.nameMain]: {
            ...state.graphsInfo[action.payload.nameMain],
            showChart: false,
            showMainStaticGraph: false,
            showSecondStaticGraph: true,
            loadedSecondStaticGraph: true,
            staticGraphToShow: 1,
            dataSecondStaticGraph: {
              ...state.graphsInfo[action.payload.nameMain].dataSecondStaticGraph,
              url: action.payload.url,
            },
            dataThirdStaticGraph: {
              ...state.graphsInfo[action.payload.nameMain].dataThirdStaticGraph,
              url: action.payload.url,
            },
          },
        },
      };
    case 'FETCH_THIRD_SINGLE_STATIC_GRAPHS_SUCCESS':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.nameMain]: {
            ...state.graphsInfo[action.payload.nameMain],
            showChart: false,
            showMainStaticGraph: false,
            showSecondStaticGraph: false,
            loadedSecondStaticGraph: false,
            showThirdStaticGraph: true,
            loadedThirdStaticGraph: true,
            staticGraphToShow: 2,
            dataSecondStaticGraph: {
              ...state.graphsInfo[action.payload.nameMain].dataSecondStaticGraph,
              url: action.payload.url,
            },
            dataThirdStaticGraph: {
              ...state.graphsInfo[action.payload.nameMain].dataThirdStaticGraph,
              url: action.payload.url,
            },
          },
        },
      };
    case 'FETCH_PAST_EVENTS_DATA_SUCCESS':
      return {
        ...state,
        pastEventsData: action.payload,
        loaders: {
          ...state.loaders,
          pastEvents: false,
        },
      };
    case 'CREATING_THRESHOLD':
      return {
        ...state,
        creatingThreshold: action.payload,
      };
    case 'CREATING_THRESHOLD_RESPONSE':
      return {
        ...state,
        creatingThreshold: false,
        creatingThresholdResponse: action.payload,
      };
    case 'FETCH_EVENT_THRESHOLDS_SUCCESS':
      return {
        ...state,
        eventThresholds: action.payload,
        loaders: {
          ...state.loaders,
          thresholdEvents: false,
        },
      };
    case 'STATIC_GET_CHART_DATA_MULTI':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.graphName]: {
            ...state.graphsInfo[action.payload.graphName],
            showDialogMulti: true,
            loading: true,
          },
        },
      };
    case 'STATIC_SHOW_DIALOG_MULTI_THRESHOLDS':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.graphName]: {
            ...state.graphsInfo[action.payload.graphName],
            showDialogMulti: !state.graphsInfo[action.payload.graphName].showDialogMulti,
            showDialogMultiSingle: false,
          },
        },
      };
    case 'STATIC_SHOW_DIALOG_MULTI_SINGLE':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.graphName]: {
            ...state.graphsInfo[action.payload.graphName],
            showDialogMultiSingle: !state.graphsInfo[action.payload.graphName].showDialogMultiSingle,
            showDialogMulti: false,
          },
        },
      };
    case 'STATIC_FETCH_CHART_DATA_MULTI_SUCCESS':
      return {
        ...state,
        graphsInfo: {
          ...state.graphsInfo,
          [action.payload.graphName]: {
            ...state.graphsInfo[action.payload.graphName],
            loadedData: true,
            data: action.payload.data,
            loading: false,
          },
        },
      };
    default:
      return state;
  }
};

export default staticLookerDashboard;
